import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=5a2cbc6d&scoped=true&"
import script from "./FormControl.vue?vue&type=script&lang=ts&"
export * from "./FormControl.vue?vue&type=script&lang=ts&"
import style0 from "./FormControl.vue?vue&type=style&index=0&id=5a2cbc6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cbc6d",
  null
  
)

export default component.exports